<mat-card class="example-card">
  <h2 class="mat-h2">Suche nach Zugängen</h2>
  <mat-card-content>
    <div class="example-container">
      <form [formGroup]="filterForm">
        <mat-form-field appearance="outline">
          <mat-label>Eingabe</mat-label>
          <input (keyup)="liveSearch()"
                 (focusout)="closeSuggestions()"
                 matInput
                 formControlName="input">
          <ng-container *ngIf="suggestions">
            <ul class="search-suggestions">
              <li *ngFor="let s of suggestions" (click)="open(s)">{{s.name}}</li>
            </ul>
          </ng-container>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Spalte</mat-label>
          <mat-select [(value)]="filterForm.value['column']" formControlName="column">
            <mat-option *ngFor="let col of columns" value="{{col.value}}">{{col.title}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="button-field">
          <button (click)="submit()" mat-raised-button color="accent">Suchen
            <mat-icon mat-list-icon>search</mat-icon>
          </button>
        </div>
        <div class="button-field">
          <button class="reset" (click)="reset()" mat-raised-button>Zurücksetzen
            <mat-icon mat-list-icon>clear</mat-icon>
          </button>
        </div>

      </form>
    </div>

  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>
</mat-card>

<mat-card *ngIf="customers">
  <h3 mat-subheader>Kunden / Unternehmen</h3>

  <!--  Table-->
  <ng-container *ngIf="customersDataSource">
    <table mat-table [dataSource]="customersDataSource" matSort (matSortChange)="sortResults($event)"
           class="customer-table">

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let customer">
          <mat-icon mat-list-icon>work</mat-icon>
        </td>
      </ng-container>
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
        <td mat-cell *matCellDef="let customer"> {{customer.name}} </td>
      </ng-container>

      <ng-container matColumnDef="entry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Registrierungsdatum</th>
        <td mat-cell *matCellDef="let customer"> {{customer.entry | date:'short'}} </td>
      </ng-container>

      <ng-container matColumnDef="valid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Gültig</th>
        <td mat-cell *matCellDef="let customer"> {{customer.valid ? 'Ja' : 'Nein'}} </td>
      </ng-container>

      <ng-container matColumnDef="edit" class="edit-customer">
        <th mat-header-cell *matHeaderCellDef> Bearbeiten</th>
        <td mat-cell (click)="open(customer)" *matCellDef="let customer">
          <mat-icon mat-list-icon>edit</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>


  <!--  end Table-->

  <mat-paginator *ngIf="pager.length && pager.length > 5"
                 [length]="pager.length"
                 [pageSize]="pager.pageSize"
                 [pageIndex]="pager.pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="switchPage($event)">
  </mat-paginator>
</mat-card>

